export default __webpack_public_path__ + "static/media/Group 1285.6929b8bd.png";